import { render, staticRenderFns } from "./HeaderImage.vue?vue&type=template&id=3267ca8b"
import script from "./HeaderImage.vue?vue&type=script&lang=js"
export * from "./HeaderImage.vue?vue&type=script&lang=js"
import style0 from "./HeaderImage.vue?vue&type=style&index=0&id=3267ca8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports